import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_gj9ncccmtc: FaireCollectionEntity = {
  token: "pbc_gj9ncccmtc",
  type: "collection",
  name: "In-Stock Baby Overall Outfits (Sweater Knits)",
  heroImageUrl:
    "https://cdn.faire.com/fastly/30296db7f05f79ac4ed783b42999be156ddee31da502513504a4880e4e28b402.jpeg",
  itemCount: 24,
  description:
    "Explore our in-stock collection of organic cotton baby overall outfits in soft sweater knits. Ready to ship, these cozy coordinated styles pair timeless design with breathable comfort, making them perfect for everyday wear.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:19.666Z",
    importedBy: "entity-db-import-collections",
  },
};
